import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";

import "react-tippy/dist/tippy.css";
import 'semantic-ui-css/semantic.min.css';

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import configureStore from "./store";

import "./App.css";
import "./index.css";
import "./template.css";

ReactDOM.render(
  <Provider store={configureStore()}>
    <App />
  </Provider>
  , document.getElementById("root")
);

serviceWorker.unregister();